export const zh_TW = {
    translation: {
        b: {
            cancel: '取消',
            confirm: '確認',
            send: '傳送',
            done: '完成',
            close: '關閉',
            clear: '清除',
            copy_link: '複製連結',
            export: '匯出',
            delete: '刪除',
            delete_confirm: '確認刪除',
            duplicate: '複製',
            share: '分享',
            sign_in: '登入',
            sign_up: '註冊',
            email_address: '電子郵件地址',
            yes: '是',
            no: '否',
            back: '返回',
            upgrade: '升級',
            remove: '移除',
            restore: '還原',
            archive: '封存',
            rename: '重新命名',
            leave: '離開',
            import: '匯入',
            continue: '繼續',
            settings: '設定',
            log_out: '登出',
            invite: '邀請',
            invited: '已邀請',
        },
        roles: {
            view: '檢視者',
            comment: '留言者',
            edit: '編輯者',
            admin: '管理員',
            owner: '擁有者',
            member: '成員',
            remove: '移除',
            more_roles: '更多角色...',
            change_role: '變更角色...',
            remove_access: '移除存取權限...',
            remove_invite: '移除邀請...',
        },
        db_engine: {
            basic: '基本 SQL',
            general: '一般 SQL',
        },
        socket_status: {
            reconnecting: '正在重新連線...',
            offline: '您已離線，正在重新連線...',
        },
        loader: {
            diagram: '正在載入圖表...',
        },
        m_languages: {
            title: '語言',
            subtitle: '選擇語言'
        },
        m_feedback: {
            feature: {
                name: '功能請求',
                desc: '缺少您需要的功能嗎？告訴我們 — 您的點子很重要'
            },
            feedback: {
                name: '分享您的意見回饋',
                desc: '我們很想聽聽您的想法'
            },
            support: {
                name: '支援',
                desc: '遇到問題了嗎？告訴我們 — 我們會盡快為您處理',
            },
            bug: {
                name: '回報問題',
                desc: '發現不太對勁的地方嗎？回報給我們 — 我們會盡快處理',
            },
            integration: {
                name: '請求整合',
                desc: '您的回饋對我們非常重要 — 請留下簡短訊息',
            },
        },
        m_feedback_t: {
            feature: {
                name: '感謝您的建議！',
                desc: '感謝您撥冗分享想法 — 這有助於我們把產品做得更好。'
            },
            feedback: {
                name: '感謝您的回饋！',
                desc: '感謝您撥冗分享想法 — 這有助於我們把產品做得更好。'
            },
            support: {
                name: '感謝您與我們聯絡！',
                desc: '感謝您聯絡支援團隊 — 我們會盡快審核您的請求並回覆。',
            },
            bug: {
                name: '感謝您的回報！',
                desc: '感謝您回報此問題 — 這有助於我們更快修復並持續改善體驗。',
            },
            contact: {
                name: '感謝您與我們聯絡！',
                desc: '我們已收到您的訊息，會盡快回覆您。',
            },
            invite_people: {
                name: '邀請已成功送出！',
                desc: '感謝您幫忙推廣 — 我們很期待迎接他們的加入。',
            },
            integration: {
                name: '感謝您的建議！',
                desc: '感謝您撥冗分享想法 — 這有助於我們把產品做得更好。',
            },
        },
        m_diagram_details: {
            name_place: '輸入專案名稱',
            desc_place: '輸入專案說明'
        },
        m_quick_share: {
            title: '快速分享',
            subtitle: '（基於查詢的連結分享）'
        },
        m_export_img: {
            title: '匯出圖片'
        },
        search_menu: {
            placeholder: '搜尋資料表、欄位、類型...',
            hint: '',
            no_results: '沒有結果',
            quick_results: '快速搜尋結果：',
            untitled: '未命名',
            command_tag: '指令',
            section_tables: '資料表',
            section_columns: '欄位',
            section_canvas: '畫布',
            section_export: '匯出',
            section_preferences: '偏好設定',
            section_settings: '設定',
            type_table: '資料表',
            type_note: '註記',
            cmd_new_table: '建立新資料表...',
            cmd_new_note: '建立新註記...',
            cmd_new_line: '建立新連線...',
            cmd_new_area: '建立新區域...',
            cmd_export_image: '匯出圖片...',
            cmd_export_sql: '匯出 SQL 程式碼...',
            cmd_grid_style: '變更網格版面...',
        },
        canvas_table: {
            more_column: '更多欄位',
            more_columns: '更多欄位',
            tooltip_table: '資料表',
            tooltip_indexes: '索引',
            tooltip_enum: '列舉',
            tooltip_default: '預設值',
            tooltip_generated: '產生值',
            tooltip_check: '檢查約束',
        },
        m_export_code: {
            title: '匯出 {{db_engine}} 程式碼',
            download_file: '下載檔案',
            copy_code: '複製程式碼'
        },
        m_sign_in_remind: {
            title: '感謝您試用 DB Design',
            subtitle: '登入或註冊即可提高資料表數量上限、儲存圖表，並解鎖更多功能。'
        },
        m_sign_in_restrict: {
            title: '登入以在 App 中做更多事',
            subtitle: '登入或註冊即可提高資料表限制、儲存圖表，並解鎖更多功能。'
        },
        m_new_diagram: {
            title: '新增圖表',
            subtitle: '選擇資料庫引擎',
            open_diagram: '開啟圖表',
            create_diagram: '建立圖表',
            no_workspace: '請先建立工作區，才能開始建立圖表。',
            build_something_new: '一起打造新事物吧',
            create_diagram_section: '建立圖表',
            clone_template_btn: '複製範本',
        },
        m_diagram_name: {
            enter_new_name: '輸入新的圖表名稱',
        },
        m_diagram_clone: {
            header: '複製圖表',
            copy_of_title: '{{title}} 的副本',
        },
        m_diagram_rename: {
            header: '重新命名圖表',
        },
        m_template_clone: {
            header: '從範本建立圖表',
        },
        m_diagram_delete: {
            header: '刪除圖表',
            desc_prefix: '這將刪除 ',
        },
        m_diagram_archive: {
            header: '封存圖表',
            desc_prefix: '這將封存 ',
        },
        m_diagram_restore: {
            header: '還原圖表',
            desc_prefix: '這將還原 ',
        },
        m_diagram_import: {
            sql_name: '匯入 SQL 程式碼',
            dbml_name: '匯入 DBML 程式碼',
            placeholder: '我們很樂意聽聽您的想法！',
        },
        m_diagram_not_found: {
            header: '找不到圖表',
            desc: '我們找不到您要找的圖表。',
            back_to_app: '返回應用程式',
        },
        m_diagram_share: {
            header: '分享圖表 – {{title}}',
            owner_only_invite: '只有擁有者可以邀請新成員',
            invited_to_workspace: '已邀請加入工作區',
            you: '您',
            email_placeholder: '輸入電子郵件',
            email_already_in_list: '此電子郵件已在清單中',
            will_be_invited_to_workspace: '將被邀請加入工作區',
        },
        m_invite_people: {
            header: '邀請加入工作區',
        },
        m_invite_revoke: {
            header: '移除邀請',
            desc_prefix: '移除對以下對象的邀請：',
            desc_suffix: '該邀請將失效。',
        },
        m_member_remove: {
            header: '移除成員',
            desc_prefix: '移除 ',
            desc_suffix: '？此人將失去存取權限。',
        },
        m_template_details: {
            preview: '預覽',
            use_template: '使用範本',
        },
        m_workspace_create: {
            header: '建立新工作區',
            name_label: '名稱',
            setup_config_label: '設定配置',
            setup_config_value: '空白工作區',
            template_structure_label: '範本／結構',
            template_structure_value: '預先載入結構',
            placeholder: '輸入工作區名稱',
            create_button: '建立工作區',
            creating: '正在建立工作區...',
        },
        m_workspace_delete: {
            header: '刪除工作區',
            desc_prefix: '這將永久刪除 ',
            confirm_prefix: '請輸入 ',
            confirm_suffix: ' 以確認。',
        },
        m_workspace_leave: {
            header: '離開工作區',
            desc_prefix: '這將把您從 ',
            desc_suffix: '中移除。若要重新加入，需重新獲得邀請。',
        },
        m_workspace_menu: {
            manage_members: '管理成員',
            switch_workspace: '切換工作區',
            workspaces_label: '工作區',
            create_workspace: '建立工作區...',
            switching: '正在切換',
        },
        m_profile_menu: {
            profile: '個人資料',
            onboarding: '新手引導',
        },
        m_pricing_limit: {
            admin_roles: { title: '讓協作更上一層樓', description: '升級以解鎖更多共享角色，例如管理員、編輯者、留言者、檢視者。' },
            workspaces: { title: '您正在快速成長！', description: '升級以建立並管理更多工作區，支援您的專案與團隊。' },
            workspaces_canvas: { title: '擴展您的工作區', description: '升級以建立並管理更多工作區，支援您的專案與團隊。' },
            members: { title: '大規模協作', description: '升級以邀請更多成員加入工作區，實現更有效的協作。' },
            diagrams: { title: '您正在快速成長！', description: '升級以建立更多圖表，並更有信心地推進您的專案。' },
            tables: { title: '無限制建立', description: '升級以新增更多資料表，持續打造更大、更詳細的圖表。' },
            columns: { title: '無限制建立', description: '升級以新增更多欄位，持續打造更大、更詳細的圖表。' },
            notes: { title: '無限制建立', description: '升級以新增更多便利貼，持續打造更大、更詳細的圖表。' },
            areas: { title: '無限制建立', description: '升級以新增更多區域，持續打造更大、更詳細的圖表。' },
            pens: { title: '無限制建立', description: '升級以新增更多繪圖，持續打造更大、更詳細的圖表。' },
            default_title: '讓協作更上一層樓',
            default_title_canvas: '讓效能更上一層樓',
        },
        m_pricing_plans: {
            title: '升級您的方案',
            subtitle: '您可以隨時升級或降級您的方案',
            monthly: '按月',
            annually: '按年',
            billed_annually: '按年計費',
            billed_monthly: '按月計費',
            free_for_everyone: '人人免費',
            current_plan: '目前方案',
            will_be_available_soon: '即將推出',
            price_period_user_month: '/使用者/月',
            plan_free: {
                name: '免費版',
                button: '變更方案',
                feature_realtime: '即時協作',
                feature_members: '每個工作區 4 名成員',
                feature_diagrams: '每個工作區 4 個圖表',
                feature_tables: '每個圖表 40 張資料表',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: '包含免費版所有功能 +',
                feature_members: '成員數量無限',
                feature_diagrams: '圖表數量無限',
                feature_tables: '資料表數量無限',
                feature_history: '版本歷史紀錄',
                feature_admin_roles: '管理員角色',
            },
        },
        sidebar: {
            new: '新增',
            pinned_diagrams: '已釘選的圖表',
            pin_hint: '釘選圖表後將顯示於此',
            expand_sidebar: '展開側邊欄',
            home_aria: 'DB Design 首頁',
            open_menu: '開啟選單',
            close_menu: '關閉選單',
            sidebar_menu_aria: '側邊欄選單',
            plan_suffix: '方案',
            diagram_options: '圖表選項',
            pin: '釘選',
            unpin: '取消釘選',
            edit_details: '編輯詳細資料',
            see_details: '查看詳細資料',
            invite_people: '邀請',
            collapse_sidebar: '收合側邊欄',
            close_sidebar: '關閉側邊欄',
            open_sidebar: '開啟側邊欄',
            open_new_tab: '在新分頁中開啟',
        },
        focus_controls: {
            show_top: '顯示頂部控制項',
            hide_top: '隱藏頂部控制項',
            show_left: '顯示左側控制項',
            hide_left: '隱藏左側控制項',
        },
        m_keyboard_shortcuts: {
            title: '鍵盤快速鍵',
            general: {
                title1: '一般',
                title2: '',
                items: {
                    new_diagram: '建立圖表',
                    new_chat: '新增對話',
                    search: '快速操作或搜尋',
                    preferences: '偏好設定',
                    settings: '設定',
                    keyboard_shortcuts: '鍵盤快速鍵',
                    toggle_sidebar: '切換側邊欄',
                    toggle_theme: '切換主題',
                },
            },
            ctrl_left: {
                title1: '控制',
                title2: '(左側)',
                items: {
                    mouse_sel: '滑鼠選取／手形模式',
                    table: '資料表',
                    line: '連線',
                    area: '區域',
                    note: '註記',
                    comment: '註解',
                    pen: '畫筆',
                    undo: '復原',
                    redo: '重做'
                },
            },
            ctrl_top_left: {
                title1: '控制',
                title2: '(左上角)',
                items: {
                    export_img: '匯出圖片',
                    search: '搜尋',
                    editor_panel: '編輯器面板',
                    zoom_to_fit: '調整為適合螢幕',
                },
            },
            ctrl_bottom_right: {
                title1: '控制',
                title2: '(右下角)',
                items: {
                    minimap: '小地圖',
                    full_screen: '全螢幕',
                    zoom_in: '放大',
                    zoom_out: '縮小',
                    zoom_100: '100% 縮放'
                },
            },
            ctx_tab: {
                title1: '內容功能表',
                title2: '(資料表)',
                items: {
                    dupl_tab: '複製資料表',
                    del_tab: '刪除資料表'
                },
            },
            ctx_del_tab: {
                title1: '內容功能表',
                title2: '(刪除資料表)',
                items: {
                    yes: '是',
                    no: '否'
                },
            },
            ctx_tab_col: {
                title1: '內容功能表',
                title2: '(資料表欄位)',
                items: {
                    add_col_below: '在下方新增欄位',
                    focus_col_above: '將焦點移至上方欄位',
                    focus_col_below: '將焦點移至下方欄位',
                    move_col_up: '將欄位上移',
                    move_col_down: '將欄位下移',
                    dupl_col: '複製欄位',
                    del_col: '刪除欄位'
                },
            },
            ctx_line: {
                title1: '內容功能表',
                title2: '(連線)',
                items: {
                    del_line: '刪除連線'
                },
            },
            ctx_area: {
                title1: '內容功能表',
                title2: '(區域)',
                items: {
                    dupl_area: '複製區域',
                    del_area: '刪除區域'
                },
            },
            ctx_multi: {
                title1: '內容功能表',
                title2: '(多重選取)',
                items: {
                    select_all: '選取所有元素',
                    create_area_for_select_els: '為選取元素建立區域',
                    dupl_select_els: '複製選取的元素',
                    del_select_els: '刪除選取的元素'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: '滑鼠選取',
                table: '資料表',
                line: '連線',
                area: '區域',
                note: '註記',
                comment: '註解',
                pen: '畫筆',
                undo: '復原',
                redo: '重做'
            },
            ctrl_top_left: {
                home: '首頁',
                name: '圖表資訊',
                editor: '編輯器',
                search: '搜尋',
                export: '匯出選項',
                view_mode: '檢視模式',
                zoom_to_fit: '調整為適合螢幕',
                grid: '網格版面',
                history: '歷史紀錄',
                main_menu: '主選單',
                new_diagram: '新增圖表',
            },
            ctrl_top_right: {
                feature_req: '功能請求',
                feedback: '傳送意見回饋',
                sign_in: '登入',
                quick_share: '快速分享'
            },
            ctrl_bottom_right: {
                full_screen: '全螢幕',
                minimap: '小地圖',
                zoom_out: '縮小',
                zoom_100: '100% 縮放',
                zoom_in: '放大',
                info: '資訊與資源'
            },
            ctx: {
                base: {
                    colors: {
                        default: '預設',
                        blue: '藍色',
                        green: '綠色',
                        red: '紅色',
                        purple: '紫色',
                        violet: '紫羅蘭色'
                    },
                    borders: {
                        none: '無',
                        solid: '實線',
                        dashed: '虛線',
                        dotted: '點線'
                    },
                    color: '顏色',
                    border: '邊框',
                    description: '說明',
                    description_table_place: '資料表說明',
                    description_column_place: '欄位說明',
                    description_line_place: '連線說明',
                    description_note_place: '註記說明',
                    description_area_place: '區域說明',
                    description_pen_place: '畫筆說明',
                    hide_menu: '隱藏功能表',
                    show_menu: '顯示功能表'
                },
                tab_col: {
                    add_col_below: '在下方新增欄位',
                    add_col_above: '在上方新增欄位',
                    key: 'Key',
                    keys: {
                        none: '無',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: '無',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '欄位下移',
                    move_col_up: '欄位上移',
                    more_functions: '更多功能'
                },
                line: {
                    change_connects: '變更連接器',
                    connects: {
                        empty: '空',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: '過濾元素'
                },
                note: {
                    link_placeholder: '輸入連結',
                    link_apply: '新增',
                    link_remove: '移除',
                    link_edit: '編輯',
                    link_needs_selection: '選取文字以新增連結',
                    bulleted_list: '清單',
                    numbered_list: '編號清單',
                    font_style: '字型樣式',
                    alignment: '對齊方式',
                    align_left: '靠左對齊',
                    align_center: '置中對齊',
                    align_right: '靠右對齊',
                    link: '連結',
                    monospace: '等寬字體',
                    bold: '粗體',
                    italic: '斜體',
                    underline: '底線',
                    strikethrough: '刪除線',
                },
                multi: {
                    filter: '過濾選取內容',
                    create_area: '建立區域'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '完整',
            keys_only: '僅鍵',
            names_only: '僅名稱'
        },
        dropdown_ctrl_grid: {
            none: '無',
            lines: '線條',
            dots: '點',
        },
        dropdown_ctrl_export: {
            export_img: '匯出圖片',
            export_code: '匯出 SQL 程式碼'
        },
        dropdown_ctrl_settings: {
            back_home: '返回首頁',
            sign_in: '登入',
            preferences: '偏好設定',
            new_project: '新增專案',
            import_diagram: '匯入圖表',
            duplicate_diagram: '複製圖表',
            keyboard_shortcuts: '鍵盤快速鍵',
            languages: '語言',
            view: '檢視',
            upgrade_plan: '升級方案',
            language: '語言',
            mouse_trackpad: '滑鼠或觸控板',
            background_color: '背景顏色',
            grid_layout: '網格版面',
            view_mode: '檢視模式',
            show_align_lines: '顯示對齊線',
            show_members_cursors: '顯示成員游標',
            show_comments: '顯示留言',
            undo_redo_controls: '復原／重做控制項',
            show_scrollbars: '顯示捲軸',
            opt_auto: '自動',
            opt_trackpad: '觸控板',
            opt_mouse: '滑鼠',
            opt_default: '深色（預設）',
            opt_gray: '灰色',
            opt_blue: '藍色',
            opt_purple: '紫色',
            opt_violet: '紫羅蘭色',
            opt_green: '綠色',
            opt_red: '紅色',
            opt_yellow: '黃色',
            opt_dots: '點',
            opt_lines: '線條',
            opt_none: '無',
            opt_full: '完整',
            opt_keys: '鍵',
            opt_names: '名稱',
        },
        dropdown_ctrl_info_resources: {
            feedback: '意見回饋',
            keyboard_shortcuts: '鍵盤快速鍵',
            languages: '語言',
            homepage: '首頁'
        },
        n: {
            default: '載入中…',
            file_ready_to_download: '檔案已可供下載',
            code_copied: '程式碼已複製',
            link_copied: '連結已複製',
            username_copied: '使用者名稱已複製',
            email_copied: '電子郵件已複製',
            please_enter_message: '請輸入訊息',
            invalid_email: '電子郵件地址無效',
            note_link_unsupported_protocol: '不支援此連結類型。請使用 https、http、mailto。',
            something_wrong_contact: '發生錯誤。請重新載入頁面或與我們聯絡。',
            something_wrong: '發生錯誤。請重新載入頁面。',
            sending: '傳送中…',
            request_sent: '請求已送出。謝謝!',

            please_enter_email: '請輸入電子郵件地址',
            changing: '正在變更...',
            role_changed: '角色已變更',
            removing: '正在移除...',
            member_removed: '成員已移除',
            inviting: '正在邀請...',
            invite_sent: '邀請已送出',
            added_to_diagram: '已加入圖表',
            invite_removed: '邀請已移除',
            role_not_allowed_on_plan: '目前方案不支援此角色。升級後即可指派。',
            already_diagram_member: '此人已可存取此圖表。',
            cannot_invite_to_workspace: '請請工作區管理員邀請此人加入工作區。',
            saving: '正在儲存...',
            saved: '已儲存',
            diagram_renamed: '圖表已重新命名',
            diagram_updated: '圖表已更新',
            duplicating: '正在複製...',
            diagram_duplicated: '圖表已複製',
            deleting: '正在刪除...',
            diagram_archived: '圖表已封存',
            diagram_deleted: '圖表已刪除',
            restoring: '正在還原...',
            diagram_restored: '圖表已還原',
            diagram_pinned: '圖表已釘選',
            diagram_unpinned: '圖表已取消釘選',
            creating: '正在建立...',
            diagram_created: '圖表已建立',
            forbidden: '您沒有存取權限。',
            invite_already_pending: '此人已有一個待處理的邀請。',
            already_member: '已是工作區成員',
            cannot_invite_self: '無法邀請自己',
            workspace_not_found: '找不到工作區。請重新整理頁面後再試一次。',
            diagram_not_found: '找不到圖表。',
            has_diagram_members: '此圖表有活躍成員',
            seat_limit_reached: '您已達到方案的席次上限。升級以邀請更多人。',
            feature_not_in_plan: '此功能不包含在您目前的方案中。',
            subscription_expired: '您的訂閱已過期。請續訂以繼續使用。',
            subscription_inactive: '您的訂閱未啟用。請更新帳單資訊。',
            plan_limit_generic: '您目前的方案不允許此操作。升級後即可繼續。',

            // Auth / profile
            session_expired: '您的工作階段已過期 — 請重新登入。',
            profile_updated: '個人資料已更新',
            profile_update_failed: '更新個人資料失敗。',
            account_delete_failed: '刪除帳戶失敗。',

            // Preferences
            couldnt_save: '無法儲存變更',
            try_again: '發生錯誤，請再試一次。',

            // Workspace
            not_workspace_member: '您不是該工作區的成員。',
            workspace_switch_failed: '無法切換工作區，請再試一次。',
            workspace_create_failed: '無法建立工作區，請再試一次。',
            invalid_workspace_name: '工作區名稱無效',
            workspace_updated: '工作區已更新',
            workspace_update_failed: '無法更新工作區，請再試一次。',
            last_owner_cannot_leave: '您是唯一的擁有者。請先將其他人設為擁有者，或刪除該工作區，再離開。',
            workspace_leave_failed: '無法離開工作區，請再試一次。',
            workspace_delete_forbidden: '只有工作區擁有者可以刪除此工作區。',
            workspace_has_active_billing: '請先取消此工作區的訂閱，再進行刪除。',
            workspace_deleted: '工作區已刪除',
            workspace_delete_failed: '無法刪除工作區，請再試一次。',
            member_remove_forbidden: '您無權移除此成員。',
            member_remove_failed: '無法移除成員，請再試一次。',
            cannot_remove_self: '若要移除自己，請使用「離開工作區」。',
            cannot_remove_last_owner: '工作區必須始終有一位擁有者。請先將其他人設為擁有者。',
            invite_revoke_forbidden: '您無權撤銷此邀請。',
            invite_revoke_failed: '無法撤銷邀請，請再試一次。',
        },
        dashboard: {
            doc_title: '圖表',
            filter_all: '全部',
            filter_mydiagrams: '我的圖表',
            filter_shared: '與我共用',
            filter_archived: '已封存',
            empty_all: '"全部圖表"中沒有圖表',
            empty_mydiagrams: '"我的圖表"中沒有圖表',
            empty_shared: '"與我共用"中沒有圖表',
            empty_archived: '"已封存"中沒有圖表',
            example_diagram_badge: '範例圖表',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: '返回應用程式',
                group_personal: '個人',
                group_organization: '組織',
                billing: '帳單',
            },
            profile: {
                member_since: '加入於 {{date}}',
                general: '一般',
                email: '電子郵件',
                full_name: '姓名',
                full_name_placeholder: '輸入姓名',
                account_protection: '帳戶保護',
                mfa_label: '多重要素驗證 (MFA)',
                mfa_sub: '為帳戶增加一層額外的安全防護 · 即將推出',
                mfa_enable: '啟用 MFA',
                mfa_soon_tooltip: '即將推出',
                workspace_access: '工作區存取權',
                leave_workspace: '離開工作區',
                leave_workspace_sub: '將您從工作區中移除',
                leave_owner_tooltip: '離開前請先轉移擁有權',
            },
            workspace: {
                header: '工作區',
                general: '一般',
                name_label: '工作區名稱',
                name_placeholder: '工作區名稱',
                stat_member_singular: '成員',
                stat_member_plural: '成員',
                stat_team_singular: '團隊',
                stat_team_plural: '團隊',
                members_section: '成員',
                no_members: '尚無成員',
                count_member_singular: '成員',
                count_member_plural: '成員',
                view_members_btn: '檢視成員',
                danger_zone: '危險區域',
                delete_workspace: '刪除工作區',
                delete_workspace_sub: '這將永久刪除此工作區',
                delete_owner_only_tooltip: '只有擁有者可以刪除工作區',
                delete_cancel_sub_tooltip: '刪除工作區前請先取消訂閱',
            },
            members: {
                header: '成員',
                col_name: '姓名',
                col_email: '電子郵件',
                col_role: '角色',
                col_joined: '加入時間',
                active_members: '活躍成員',
                invited_section: '已邀請',
                no_members: '尚無成員。',
                options_aria: '選項',
                leave_workspace_item: '離開工作區…',
                remove_member_item: '移除成員…',
                remove_owner_only_tooltip: '只有擁有者可以移除成員',
                remove_owner_row_tooltip: '無法將擁有者移出工作區',
                remove_invite_item: '移除邀請…',
                role_invited_suffix: '{{role}}（已邀請）',
            },
            preferences: {
                section_general: '一般',
                section_diagram_defaults: '圖表設定',
                section_diagram_views: '圖表檢視',
                section_notifications: '通知',
                theme_label: '介面主題',
                theme_sub: '選擇介面配色方案',
                theme_dark: '深色',
                theme_light: '淺色',
                theme_system: '跟隨系統',
                language_sub: '選擇介面語言',
                timezone_label: '時區',
                timezone_sub: '選擇您的時區',
                timezone_options: {
                    honolulu: 'GMT-10:00 — 夏威夷',
                    anchorage: 'GMT-09:00 — 阿拉斯加',
                    los_angeles: 'GMT-08:00 — 太平洋時間',
                    denver: 'GMT-07:00 — 山地時間',
                    chicago: 'GMT-06:00 — 中部時間',
                    new_york: 'GMT-05:00 — 東部時間',
                    caracas: 'GMT-04:00 — 加拉加斯',
                    sao_paulo: 'GMT-03:00 — 聖保羅',
                    azores: 'GMT-01:00 — 亞速爾群島',
                    london: 'GMT+00:00 — 倫敦',
                    paris: 'GMT+01:00 — 巴黎、柏林',
                    kyiv: 'GMT+02:00 — 基輔、雅典',
                    istanbul: 'GMT+03:00 — 伊斯坦堡',
                    dubai: 'GMT+04:00 — 杜拜',
                    karachi: 'GMT+05:00 — 喀拉蚩',
                    kolkata: 'GMT+05:30 — 印度',
                    dhaka: 'GMT+06:00 — 達卡',
                    bangkok: 'GMT+07:00 — 曼谷、雅加達',
                    shanghai: 'GMT+08:00 — 北京、新加坡',
                    tokyo: 'GMT+09:00 — 東京、首爾',
                    sydney: 'GMT+10:00 — 雪梨',
                    auckland: 'GMT+12:00 — 奧克蘭',
                },
                input_mode_sub: '選擇畫布導覽控制方式',
                background_sub: '為畫布選擇背景顏色',
                grid_sub: '選擇畫布網格版面配置',
                show_align_lines_sub: '對齊物件時顯示輔助線',
                show_cursors_sub: '顯示其他協作者的游標',
                show_comments_sub: '在畫布上顯示留言',
                show_scrollbars_sub: '瀏覽畫布時顯示捲動軸',
                show_undo_redo_label: '顯示復原/取消復原控制項',
                show_undo_redo_sub: '顯示用於復原和取消復原變更的控制項',
                notif_shared_label: '與我共用的圖表',
                notif_shared_sub: '當有人與我共用圖表時',
                notif_mentions_label: '留言中的提及',
                notif_mentions_sub: '當有人在留言中 @提及我時',
                notif_updates_label: '產品更新',
                notif_updates_sub: '關於新功能與改進的每月更新',
                show: '顯示',
                hide: '隱藏',
                on: '開啟',
                off: '關閉',
            },
            billing: {
                header: '帳單',
                plan_free: '免費方案',
                status_current: '目前',
                no_renewal_needed: '不需要續訂',
                payment_header: '付款',
                no_payments: '尚無付款',
                invoices_header: '發票',
                no_invoices: '尚無發票',
            },
            usage: {
                doc_title: '用量',
                overview_title: '總覽',
                resource_limits_title: '資源限制',
                label_diagrams: '圖表',
                label_tables: '資料表',
                label_areas: '區域',
                label_notes: '便利貼',
                label_members: '成員',
                label_tables_per_diagram: '資料表 / 圖表',
                label_areas_per_diagram: '區域 / 圖表',
                label_notes_per_diagram: '便利貼 / 圖表',
                need_more_title: '需要更多嗎？',
                need_more_free: '升級至 Basic 方案，享有更多圖表、版本紀錄與優先支援。',
                need_more_paid: '升級至 Professional 方案，享有無限圖表、席位與進階功能。',
            },
        },
        pages: {
            not_found: {
                page_not_found: '找不到頁面',
                dont_have_access_to_diagram: '您無權存取此圖表，或該圖表已不存在。',
                back_home: '返回首頁'
            },
            error: {
                title: '錯誤',
                link_is_invalid: '此連結無效或輸入有誤。',
                something_wrong: '發生錯誤。',
                back_home: '返回首頁',
                please_try_later: '請稍後再試',
            },
            billing_success: {
                doc_title: '方案已升級',
                heading: '付款成功',
                subtitle: '您的方案已成功升級。',
                cta: '開始設計',
            },
            email_verified: {
                doc_title: '電子郵件已驗證',
            },
            forgot_password: {
                doc_title: '忘記密碼',
            },
            password_updated: {
                doc_title: '密碼已更新',
            },
            reset_password: {
                doc_title: '重設密碼',
            },
            check_email: {
                doc_title: '請查看您的電子郵件',
            },
            sign_in: {
                doc_title: '登入 {{product}}',
            },
            sign_up: {
                doc_title: '註冊 {{product}}',
            },
        },
    },
};

export const zh_TWMeta = {
    lang_origin: '繁體中文',
    lang_eng: 'Traditional Chinese',
    lang_code: 'zh-TW',
};
